import devToolMixin from '../../../util/devToolMixin';
import { get } from "lodash-es";
const __script_base__ = {
  name: 'CompPopover',
  data() {
    return {
      visible: false,
      popBody: null
    };
  },
  watch: {
    visible() {
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.popBody = this.windowRef.document.getElementsByClassName('ant-popover-inner')[0];
      });
    }
  },
  mixins: [devToolMixin],
  methods: {
    handleSelect(value, option) {
      const {
        layout
      } = get(this.compsData, option.key);
      this.handleInsertComp(layout);
      this.visible = false;
    }
  },
  computed: {
    compsData() {
      if (!this.bus.layoutOpts.compSearchInput) return this.componentGroups;
      const res = this.componentGroups.map(({
        items,
        ...rest
      }) => ({
        ...rest,
        items: items.filter(item => {
          var _item$name, _item$layout$type;
          const k = this.bus.layoutOpts.compSearchInput.toLowerCase();
          return rest.name.toLowerCase().includes(k) || ((_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(k)) || ((_item$layout$type = item.layout.type) === null || _item$layout$type === void 0 ? void 0 : _item$layout$type.toLowerCase().includes(k));
        })
      }));
      return res;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a-popover', {
    ref: "popRef",
    attrs: {
      "trigger": "click",
      "get-popup-container": function () {
        return _vm.windowRef.document.body;
      }
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('a-auto-complete', {
    style: {
      minWidth: '200px'
    },
    attrs: {
      "placeholder": "搜索组件",
      "filter-option": true,
      "get-popup-container": function () {
        return _vm.popBody || _vm.windowRef.document.body;
      },
      "default-open": true,
      "option-label-prop": "value"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('template', {
    slot: "dataSource"
  }, _vm._l(_vm.compsData, function (group, groupIndex) {
    return _c('a-select-opt-group', {
      key: group.name
    }, [_c('span', {
      key: group.name,
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(" " + _vm._s(group.name) + " ")]), _vm._v(" "), _vm._l(group.items, function (item, index) {
      return _c('a-select-option', {
        key: "[" + groupIndex + "].items[" + index + "]",
        attrs: {
          "value": group.name + "-" + item.name + "-" + item.layout.type
        }
      }, [_c('span', [_vm._v(" " + _vm._s("" + item.name) + " ")])]);
    })], 2);
  }), 1), _vm._v(" "), _c('a-input', {
    model: {
      value: _vm.bus.layoutOpts.compSearchInput,
      callback: function ($$v) {
        _vm.$set(_vm.bus.layoutOpts, "compSearchInput", $$v);
      },
      expression: "bus.layoutOpts.compSearchInput"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "suffix",
      "type": "search"
    },
    slot: "suffix"
  })], 1)], 2)], 1), _vm._v(" "), _vm.visible ? _c('a-icon', {
    attrs: {
      "type": "minus-square",
      "theme": "filled"
    }
  }) : _c('a-icon', {
    attrs: {
      "type": "plus-square",
      "theme": "filled"
    }
  })], 2);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/DevTool/components/Layout/DomTree/CompPopover.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);